import * as React from 'react'
import { render } from 'react-dom'
import { ApolloProvider } from 'react-apollo'
import ApolloClient from 'apollo-boost'

exports.wrapRootComponent = ({ Root }) => {
  const client = new ApolloClient({
    uri: 'NEED_GRAPHQL_ENDPOINT',
  })
  
  return () => (
    <ApolloProvider client={client}>
      <Root />
    </ApolloProvider>
  )
}



// WEBPACK FOOTER //
// ./gatsby-browser.js